<script setup lang="ts">
import { computed } from 'vue'
import { CONTRACT_STATES } from '@/modules/contract/constants/contract.constant.ts'
interface  Props {
  value: string
}

const props = defineProps<Props>();
const _value = computed(() => props.value)
const _label = computed(() => {
  return CONTRACT_STATES.find(state => state.id === "KHOI_TAO")?.label;
});
</script>

<template>
<div :class="`contract-state-formated ${_value.toLowerCase()}`">
    <div class="value">{{_label}}</div>
    <div class="dots">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
</div>
</template>

<style lang="scss">
.contract-state-formated{
  display: flex;
  flex-direction: column;
  gap: 0;
  margin-bottom: 5px;

  .value{
    font-weight: bold;
    height: 13px;
    color: #257a00;
  }
  .dots{
    height: 10px;
    span{
      display: inline-block;
      width: 7px;
      height: 7px;
      background: rgba(230, 230, 230, 0.73);
      border-radius: 50%;
      margin-left: 2px;
    }
  }

  &.khoi_tao{
    .dots{
      span:nth-child(1){
        background-color: #32a800;
      }
    }
  }
  &.da_ky{
    .dots{
      span:nth-child(1), span:nth-child(2){
        background-color: #32a800;
      }
    }
  }
  &.thuc_hien{
    .dots{
      span:nth-child(1), span:nth-child(2), span:nth-child(3){
        background-color: #32a800;
      }
    }
  }
  &.chot_deal{
    .dots{
      span:nth-child(1), span:nth-child(2), span:nth-child(3), span:nth-child(4){
      background-color: #32a800;
    }
    }
  }
  &.quyet_toan{
    .dots{
      span:nth-child(1), span:nth-child(2), span:nth-child(3), span:nth-child(4), span:nth-child(6){
        background-color: #32a800;
      }
    }
  }
  &.hoan_tat{
    .dots{
        background-color: #32a800;
    }
  }
}
</style>
